// constants

// action_component_subject
const COMPUTE_ADD = "COMPUTE_ADD";
const COMPUTE_ADD2 = "COMPUTE_ADD2";
const COMPUTE_REMOVE = "COMPUTE_REMOVE";
const COMPUTE_EMPTY = "COMPUTE_EMPTY";
const COMPUTE_SET = "COMPUTE_SET";

// reducers

const initialState = [];

const FourDCompute = (state = initialState, action) => {
  switch (action.type) {
    case COMPUTE_ADD:
      return [...state, { ...action.payload }];

      case COMPUTE_ADD2:
        return [...state, ...action.payload];

    case COMPUTE_REMOVE:
      let tempState = [...state];
      tempState.splice(action.payload, 1);
      return [...tempState];

    case COMPUTE_SET:
      return [...action.payload];

    case COMPUTE_EMPTY:
      return [];

    default:
      return state;
  }
};

export default FourDCompute;

export const computeAdd = (payload) => {
  return {
    type: COMPUTE_ADD,
    payload: payload,
  };
};

export const computeAdd2 = (payload) => {
  return {
    type: COMPUTE_ADD2,
    payload: payload,
  };
};

export const computeRemove = (payloadId) => {
  return {
    type: COMPUTE_REMOVE,
    payload: payloadId,
  };
};

export const computeEmpty = () => {
  return {
    type: COMPUTE_EMPTY,
  };
};

export const computeSet = (payload) => {
  return {
    type: COMPUTE_SET,
    payload: payload,
  };
};
